import {faShippingFast, faStar, faTrafficLight, faUndo} from '@fortawesome/free-solid-svg-icons';
import {FuseNavigation} from '@fuse/types';

export const customerNavigation: FuseNavigation[] = [
    {
        id: 'menu',
        title: 'Menu',
        translate: 'NAV.MENU',
        type: 'group',
        children: [
            {
                // The portal's landing screen. Points at '/' - the dashboard is rendered by the welcome
                // component's customer branch rather than a route of its own, because '/' is already
                // where login lands. Not re-using the old `client-dashboard` id: that one belonged to the
                // removed all-orders entry and still carried its haulier-order field list in
                // constants/role-settings/extra.ts, which would have hung off this item's role toggle.
                id: 'client-portal-dashboard',
                title: 'Dashboard',
                translate: 'NAV.CLIENT_PORTAL_DASHBOARD.TITLE',
                type: 'item',
                icon: 'dashboard',
                url: '/'
            },
            // No entry for the full order list (/orders/haulier-orders): that is the admin view, and the
            // portal's orders home is the Daily Manifest below. The route redirects there for customers.
            {
                // Controlled by ROLE setting key `filtered-orders-list` (hidden by default)
                id: 'filtered-orders-list',
                title: 'Filtered Orders',
                translate: 'NAV.FILTERED_ORDERS_LIST.TITLE',
                type: 'item',
                icon: 'filter_list',
                url: '/orders/filtered-orders'
            },
            {
                id: 'subcontract-dashboard',
                title: 'Orders Pending Subcontracting',
                translate: 'NAV.ORDER_SUBCONTRACT.TITLE',
                type: 'item',
                icon: 'dashboard',
                url: '/orders/haulier-order-subcontracting/pending'
            },
            {
                id: 'subcontracted-dashboard',
                title: 'Subcontracted Orders',
                translate: 'NAV.ORDER_SUBCONTRACTED.TITLE',
                type: 'item',
                icon: 'dashboard',
                url: '/orders/haulier-order-subcontracting/assigned'
            },
            {
                id: 'client-daily-manifest',
                title: 'Daily Manifest',
                translate: 'NAV.DAILY_MANIFEST.TITLE',
                type: 'item',
                icon: 'assignment',
                url: '/orders/daily-manifest'
            },
            {
                id: 'client-dedicated-vehicle-view',
                title: 'Dedicated Vehicle View',
                translate: 'NAV.DEDICATED_VEHICLE_VIEW.TITLE',
                type: 'item',
                icon: 'directions_bus',
                url: '/fleetviews'
            },
            {
                id: 'etaArrivalsBoard',
                title: 'Arrival Board',
                translate: 'NAV.ARRIVAL_BOARD.TITLE',
                type: 'item',
                url: '/history/eta-arrivals-board',
                icon: 'flight_land'
            },
            {
                id: 'invoice',
                title: 'Invoices',
                translate: 'NAV.INVOICE.TITLE',
                type: 'item',
                url: '/setup/invoices',
                faIcon: faStar
            },
            {
                id: 'order-sheet',
                title: 'Order Sheet',
                translate: 'NAV.ORDER_SHEET.TITLE',
                type: 'item',
                url: '/setup/order-sheet',
                faIcon: faTrafficLight
            },
            {
                id: 'package-returns',
                title: 'Package Returns',
                translate: 'NAV.PACKAGE_RETURNS.TITLE',
                type: 'item',
                url: '/setup/package-returns',
                faIcon: faUndo
            }
        ]
    }
];
